import React from "react"
import { Box } from "@mui/material"

import InnerAndOuterLengthConfiguration from "./InnerAndOuterLengthConfiguration"
import SystemAndLengthCombinationConfigurations from "./SystemAndLengthCombinationConfigurations"
import OuterLengthConfiguration from "./OuterLengthConfiguration"
import SystemAndOuterLengthConfiguration from "./SystemAndOuterLengthConfiguration"

import { ProductAttributes } from "@secureo/common/typings/Product"
import { GridTemplateRowName } from "../LockingSystemMatrix"
import StyledLockingSystemCell from "../StyledLockingSystemCell"
import LockingSystemItemWrapper from "../LockingSystemItemWrapper"

// TODO: Wie messe ich einen Zylinder?
export const LockingSystemRowConfigurationHeaders = () => {
	return (
		<>
			<StyledLockingSystemCell gridRowName="matrixHeader" gridColumnName="outerLength">
				<Box mt={1} style={{ textAlign: "center", color: "grey" }}>
					Außenlänge
				</Box>
			</StyledLockingSystemCell>
			<StyledLockingSystemCell gridRowName="matrixHeader" gridColumnName="innerLength">
				<Box mt={1} style={{ textAlign: "center", color: "grey" }}>
					Innenlänge
				</Box>
			</StyledLockingSystemCell>
		</>
	)
}

export const FallbackLockingSystemRowConfiguration = ({
	gridRowName,
	gridColumnName,
}: FallbackLockingSystemRowConfigurationProps) => {
	return (
		<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName={gridColumnName}>
			<LockingSystemItemWrapper>
				<Box mt={2} style={{ textAlign: "center" }}>
					-
				</Box>
			</LockingSystemItemWrapper>
		</StyledLockingSystemCell>
	)
}

interface FallbackLockingSystemRowConfigurationProps {
	gridRowName: GridTemplateRowName
	gridColumnName: "outerLength" | "innerLength"
}

const LockingSystemRowConfigurations = ({
	isLoading,
	uuid,
	gridRowName,
	attributes,
	selectedSystem,
	selectedOuterLength,
	selectedInnerLength,
	setSelectedOuterLength,
	setSelectedInnerLength,
}: Props) => {
	const {
		innerLengthsByOuterLengths,
		lengthCombinationsBySystem,
		outerLengthsBySystem,
		outerLengths,
	} = attributes

	if (innerLengthsByOuterLengths)
		return (
			<InnerAndOuterLengthConfiguration
				isLoading={isLoading}
				uuid={uuid}
				gridRowName={gridRowName}
				innerLengthsByOuterLengths={innerLengthsByOuterLengths}
				selectedOuterLength={selectedOuterLength}
				selectedInnerLength={selectedInnerLength}
				setSelectedOuterLength={setSelectedOuterLength}
				setSelectedInnerLength={setSelectedInnerLength}
			/>
		)

	if (lengthCombinationsBySystem)
		return (
			<SystemAndLengthCombinationConfigurations
				isLoading={isLoading}
				uuid={uuid}
				gridRowName={gridRowName}
				lengthCombinationsBySystem={lengthCombinationsBySystem}
				selectedSystem={selectedSystem}
				selectedOuterLength={selectedOuterLength}
				selectedInnerLength={selectedInnerLength}
				setSelectedOuterLength={setSelectedOuterLength}
				setSelectedInnerLength={setSelectedInnerLength}
			/>
		)

	if (outerLengthsBySystem)
		return (
			<SystemAndOuterLengthConfiguration
				isLoading={isLoading}
				uuid={uuid}
				gridRowName={gridRowName}
				outerLengthsBySystem={outerLengthsBySystem}
				selectedSystem={selectedSystem}
				selectedOuterLength={selectedOuterLength}
				setSelectedOuterLength={setSelectedOuterLength}
			/>
		)

	if (outerLengths)
		return (
			<OuterLengthConfiguration
				isLoading={isLoading}
				uuid={uuid}
				gridRowName={gridRowName}
				outerLengths={outerLengths}
				selectedOuterLength={selectedOuterLength}
				setSelectedOuterLength={setSelectedOuterLength}
			/>
		)

	return (
		<>
			<FallbackLockingSystemRowConfiguration
				gridRowName={gridRowName}
				gridColumnName="outerLength"
			/>
			<FallbackLockingSystemRowConfiguration
				gridRowName={gridRowName}
				gridColumnName="innerLength"
			/>
		</>
	)
}

interface Props {
	isLoading: boolean
	uuid: string
	gridRowName: GridTemplateRowName
	attributes: ProductAttributes
	selectedSystem: string
	selectedOuterLength: number
	selectedInnerLength: number
	setSelectedOuterLength?: (uuid: string, selectedOuterLength: number) => void
	setSelectedInnerLength?: (uuid: string, selectedOuterLength: number) => void
}

export default LockingSystemRowConfigurations
